import getErrorStack from './get-error-stack';
import {Logger} from './types';

const JS_UNCAUGHT = 'js_uncaught_exception';

const getLogUnhandledPromiseRejection = logger => event => {
  logger.warn({
    message: `UNHANDLED PROMISE REJECTION: ${
      event.reason instanceof Error
        ? event.reason.message
        : JSON.stringify(event.reason)
    }`,
    data: {
      stackTrace: getErrorStack(
        event.reason instanceof Error ? event.reason : new Error()
      ),
      loggerDetails: 'UNHANDLED_PROMISE_REJECTION',
    },
    name: JS_UNCAUGHT,
  });
};

const getLogUncaughtException = logger => (
  message,
  url,
  line,
  colno,
  error
) => {
  // send message and attempt to generate a stack
  logger.warn({
    name: JS_UNCAUGHT,
    message:
      message === 'Script error.' && line === 0
        ? 'Uncaught Error. Not AMD. Cannot be processed.'
        : message,
    data: {
      errorURL: url,
      stackTrace: error ? getErrorStack(error) : getErrorStack(new Error()),
      loggerDetails: 'UNCAUGHT_EXCEPTION',
    },
  });
};

export default function startUncaughtExceptionHandler(logger: Logger): void {
  const logException = getLogUncaughtException(logger);
  const logUnhandledPromiseRejection = getLogUnhandledPromiseRejection(logger);
  if (typeof window !== 'undefined') {
    window.onerror = logException;
    window.addEventListener('unhandledrejection', logUnhandledPromiseRejection);
  }
}
